import React from 'react'
import ClientSettings from './Client'
import Breadcrumb from '../../../../Components/Utils/Breadcrumb'
import { BackButton } from '../../../../Components/Utils/Buttons'
import IndexEquipment from './Equipments/Index'
import SurveyReportSettings from './SurveyReport'
import ContractsSettings from './Contracts'


function MainClientManSetting() {
    return(
        <div className='w-full h-full px-4 py-2'>
          <div className='w-full flex justify-between items-center'>
          <Breadcrumb
            items={[
              {
                name: "Settings",
              },
              {
                name: "Client Management"
              }
            ]}
          />
          <BackButton/>
          </div>
          <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto rounded-md overflow-y-scroll">
                <div className="p-3"><ClientSettings/></div>
                <div className="p-3"><SurveyReportSettings/></div>
                <div className="p-3"><ContractsSettings/></div>
                <div className="p-3"><IndexEquipment/></div>

          </div>
          </div>
      )
}

export default MainClientManSetting
